import React from 'react'

type Props = {
    role: string // Роль
    stage: string // Стадия
    isSelect: boolean // Выбрана
    isSendPerf: boolean // Исполнение отправлено
    multiSelect: boolean
    theme: string
    actions: Actions // Функции кнопок
    isLoading: boolean
    // status: string
    // multiSelect: boolean
}

type Actions = {
    upload: () => void // Отправить в ЕИС
    update: () => void // Обновить из ЕИС
    delete: () => void // Удалить
}

type ButtonConfig = {
    id: string
    label: string
    onClick: () => void
    visibleCondition: boolean // Функция, проверяющая видимость
    className?: string // Стили для кнопки
    iconPathD: string
    iconFill: string
    disabled: boolean
    isLoading: boolean
}

const TableStageToolbarDownButtons: React.FC<Props> = ({
    role,
    stage,
    theme,
    isSelect,
    isSendPerf,
    actions,
    isLoading,
    // status,
    // multiSelect,
}) => {
    const isAdmin = role === 'admin'
    const isSpecialist = role === 'specialist'
    const isCurator = role === 'curator'
    const isInitiator = role === 'initiator'

    const isEditStage = stage === 'Редактирование'
    const isRaedyStage = stage === 'Подготовка к размещению'
    const isSentToEisStage = stage === 'Отправка в ЕИС'
    const isPerfInEisStage = stage === 'Размещенное исполнение'

    // const isEditStatus = status === 'Черновик'
    // const isReadyStatus = status === 'Готово'
    // const isStandStatus = status === 'Подготовка'
    // const isReadyToEisStatus = status === 'Готово к отправке'
    // const isSentToEisStatus = status === 'Отправлено в ЕИС'
    // const isPublishedStatus = status === 'Размещена'

    const buttons: ButtonConfig[] = [
        {
            id: 'upload',
            label: 'Отправить в ЕИС',
            onClick: actions.upload,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isSelect && !isSendPerf ? 'shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187a33] dark:hover:bg-[#1d9a40]' : 'text-[#6a6a6a] dark:text-[#8a8a8a] bg-[#ededed] dark:bg-[#494849]'} `,
            iconFill: `${
                isSelect && !isSendPerf
                    ? theme == 'dark'
                        ? '#FFFFFF'
                        : '#181818'
                    : theme == 'dark'
                      ? '#8A8A8A'
                      : '#6A6A6A'
            }`,
            iconPathD:
                'M20.34,9.32l-14-7a3,3,0,0,0-4.08,3.9l2.4,5.37h0a1.06,1.06,0,0,1,0,.82l-2.4,5.37A3,3,0,0,0,5,22a3.14,3.14,0,0,0,1.35-.32l14-7a3,3,0,0,0,0-5.36Zm-.89,3.57-14,7a1,1,0,0,1-1.35-1.3l2.39-5.37A2,2,0,0,0,6.57,13h6.89a1,1,0,0,0,0-2H6.57a2,2,0,0,0-.08-.22L4.1,5.41a1,1,0,0,1,1.35-1.3l14,7a1,1,0,0,1,0,1.78Z',
            disabled: !isSelect || isSendPerf,
            isLoading: isLoading,
        },
        {
            id: 'update',
            label: 'Обновить исполнения из ЕИС',
            onClick: actions.update,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isSelect ? 'shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187a33] dark:hover:bg-[#1d9a40]' : 'text-[#6a6a6a] dark:text-[#8a8a8a] bg-[#ededed] dark:bg-[#494849]'} `,
            iconFill: `${
                isSelect
                    ? theme == 'dark'
                        ? '#FFFFFF'
                        : '#181818'
                    : theme == 'dark'
                      ? '#8A8A8A'
                      : '#6A6A6A'
            }`,
            iconPathD:
                'M19.91,15.51H15.38a1,1,0,0,0,0,2h2.4A8,8,0,0,1,4,12a1,1,0,0,0-2,0,10,10,0,0,0,16.88,7.23V21a1,1,0,0,0,2,0V16.5A1,1,0,0,0,19.91,15.51ZM12,2A10,10,0,0,0,5.12,4.77V3a1,1,0,0,0-2,0V7.5a1,1,0,0,0,1,1h4.5a1,1,0,0,0,0-2H6.22A8,8,0,0,1,20,12a1,1,0,0,0,2,0A10,10,0,0,0,12,2Z',
            disabled: !isSelect,
            isLoading: false,
        },
        {
            id: 'delete',
            label: 'Удалить',
            onClick: actions.delete,
            visibleCondition: !isPerfInEisStage && !isSentToEisStage,
            className: `flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs ${isSelect ? 'shadow-md shadow-[#18181830] text-[#181818] bg-[#F6F6F6] hover:bg-[#ed9cae] dark:bg-[#494849] dark:hover:bg-[#701f1f] dark:text-[#FFFFFF]' : 'text-[#6a6a6a] dark:text-[#8a8a8a] bg-[#ededed] dark:bg-[#494849]'} `,
            iconFill: `${
                isSelect
                    ? theme == 'dark'
                        ? '#FFFFFF'
                        : '#181818'
                    : theme == 'dark'
                      ? '#8A8A8A'
                      : '#6A6A6A'
            }`,
            iconPathD:
                'M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z',
            disabled: !isSelect,
            isLoading: false,
        },
    ]

    return (
        <>
            {buttons
                .filter((button) => button.visibleCondition) // Оставляем только видимые кнопки
                .map((button, index) => (
                    <button
                        key={index}
                        className={button.className}
                        onClick={button.onClick}
                        // title={button.label}
                        disabled={button.disabled}
                    >
                        {button.isLoading ? (
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                        ) : (
                            <svg
                                className="w-3 h-3"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 22"
                                id={button.id}
                            >
                                <path
                                    fill={button.iconFill}
                                    d={button.iconPathD}
                                ></path>
                            </svg>
                        )}
                        {button.label}
                    </button>
                ))}
        </>
    )
}

export default TableStageToolbarDownButtons
